<template>
  <div class="global-loading-site">
    <transition name="loading">
      <van-loading color="#1989fa" class="global-loading" v-show="visible" />
    </transition>
    <div class="global-loading-background" v-show="visible" />
  </div>
</template>

<script>
import { Loading } from 'vant';

Vue.use(Loading);
export default {
  data() {
    return {
      visible: false
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    }
  },
}
</script>

<style lang="stylus" scoped>
  .global-loading {
    z-index: 999999;
    position: fixed !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .loading-enter-active, .loading-leave-active {
    transition: opacity .3s;
  }
  .loading-enter, .loading-leave-to {
    opacity: 0;
  }
  .global-loading-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    // background-color: rgba(0, 0, 0, .3);
  }
</style>
